import { render, staticRenderFns } from "./hosts.vue?vue&type=template&id=70d5cf16&scoped=true&"
import script from "./hosts.vue?vue&type=script&lang=js&"
export * from "./hosts.vue?vue&type=script&lang=js&"
import style0 from "./hosts.vue?vue&type=style&index=0&id=70d5cf16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5cf16",
  null
  
)

export default component.exports